<template>
  <v-container fluid class="tabs-content__container" v-if="showPage">
    <v-col cols="12" v-if="cancel">
      <div class="breadcrumbs">
        <span
          class="breadcrumbs__item"
          @click="returnToClientsTable"
        >
          Admin
        </span>
        <span class="breadcrumbs__item active">{{ selectedAdvertiser.data.name }}</span>
      </div>
    </v-col>
    <admin-campaign-form
      :candidate_name="candidate_name"
      :campaign_name="campaign_name"
      :website="website"
      :campaign_type="campaign_type"
      :state="state"
      :district="district"
      :reviewFileUrl="reviewFileUrl"
      :selectedAdvertiser="selectedAdvertiser"
      @updateLogo="updateLogo"
      @setField="setField"
    />

    <admin-liked-accounts
      v-if="!setupMode"
      :selectedAdvertiser="selectedAdvertiser"
    />

    <admin-setup-accounts
      v-else
    />

    <admin-user-info
      :role="role"
      :phone="phone"
      @setField="setField"
    />
    <div class="tabs-content__container-action">
      <v-row class="ma-0">
        <v-btn
          v-if="cancel"
          class="blue--text darken-4"
          @click="returnToClientsTable"
        >
          Cancel
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          @click="update"
        >Save</v-btn>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import helpers from '../../../helpers/functions'
import firebase from '../../../firebase/main'
import lodash from 'lodash'
import AdminCampaignForm from './AdminCampaignForm'
import AdminLikedAccounts from './AdminLinkedAccounts'
import AdminUserInfo from './AdminUserInfo'
import AdminSetupAccounts from './AdminSetupAccounts'

export default {
  name: 'AdminEditClient',
  components: {
    AdminCampaignForm,
    AdminLikedAccounts,
    AdminUserInfo,
    AdminSetupAccounts
  },
  data () {
    return {
      candidate_name: '',
      campaign_name: '',
      website: '',
      campaign_type: '',
      state: '',
      district: '',
      role: '',
      phone: '',
      reviewFileUrl: '',
      file: null
    }
  },
  props: {
    selectedAdvertiser: {
      type: Object,
      default: () => {}
    },
    cancel: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.fillFields()
  },
  computed: {
    ...mapGetters({
      user: 'getCurrentUser',
      advertisers: 'getAdvertisers'
    }),
    showPage () {
      if (this.selectedAdvertiser) {
        this.fillFields()
        return true
      }
      return false
    },
    setupMode () {
      if (this.user.firebaseAccount.selectedAdvertiser !== this.selectedAdvertiser.id) return false
      const setupMode = this.$store.getters.getSetupMode
      return setupMode ? setupMode.status : false
    }
  },
  methods: {
    setField (name, value) {
      this[name] = value
    },
    fillFields () {
      if (this.selectedAdvertiser) {
        const selectedAdvertiser = this.user.firebaseAccount.advertisers.find(a => a.id === this.user.firebaseAccount.selectedAdvertiser)
        this.candidate_name = this.selectedAdvertiser.data.political.candidate_name || ''
        this.campaign_name = this.selectedAdvertiser.data.name || ''
        this.website = this.selectedAdvertiser.data.website || ''
        this.campaign_type = this.selectedAdvertiser.data.political.campaign_type || ''
        this.state = this.selectedAdvertiser.data.political.state || ''
        this.district = this.selectedAdvertiser.data.political.district || ''
        this.role = selectedAdvertiser.title || ''
        this.phone = this.selectedAdvertiser.data.phone || ''
      }
    },
    updateLogo (url, file) {
      this.reviewFileUrl = url
      this.file = file
    },
    update () {
      // Note: create advertiser
      let advertiserCopy = lodash.cloneDeep(this.selectedAdvertiser)
      advertiserCopy.data.political.candidate_name = this.candidate_name
      advertiserCopy.data.name = this.campaign_name
      advertiserCopy.data.website = this.website
      advertiserCopy.data.political.campaign_type = this.campaign_type
      advertiserCopy.data.political.state = this.state
      advertiserCopy.data.political.district = this.district
      advertiserCopy.data.phone = this.phone
      // Note: create user
      let userCopy = lodash.cloneDeep(this.user.firebaseAccount)
      userCopy.advertisers.find(a => a.id === userCopy.selectedAdvertiser).title = this.role
      this.$store.dispatch('startSpinner')
      if (this.file) {
        new Promise(resolve => {
          resolve(firebase.Files.uploadImage(this.file, this.selectedAdvertiser.id))
        })
          .then(res => {
            advertiserCopy.data.logoLink = res
            return this.$store.dispatch('updateAdvertiser', advertiserCopy)
          })
          .then(() => {
            return this.$store.dispatch('updateUser', userCopy)
          })
          .then(() => {
            const message = [`<div>You updated your account successfully</div>`]
            this.$store.dispatch('showNotification', {
              type: 'success',
              message
            })
            this.$store.dispatch('createNotification', {message})
            this.$store.dispatch('stopSpinner')
          })
          .catch(err => helpers.handleError(err))
      } else {
        new Promise(resolve => {
          resolve(this.$store.dispatch('updateAdvertiser', advertiserCopy))
        })
          .then(() => {
            return this.$store.dispatch('updateUser', userCopy)
          })
          .then(() => {
            const message = [`<div>You updated your account successfully</div>`]
            this.$store.dispatch('showNotification', {
              type: 'success',
              message
            })
            this.$store.dispatch('createNotification', {message})
            this.$store.dispatch('stopSpinner')
          })
          .catch(err => helpers.handleError(err))
      }
    },
    returnToClientsTable () {
      this.$emit('returnToClientsTable')
    }
  }
}
</script>

<style scoped>
  .container {
    background-color: white;
  }
</style>
